export function formatAuthors(authors) {
    const authorArray = authors.split(" and ");
    if (authorArray.length > 2) {
        const lastAuthor = authorArray.pop();
        return `${authorArray.join(", ")}, and ${lastAuthor}`;
    }
    return authorArray.join(" and ");
}
